import React from "react";
import colors from "resources/theme/colors";
import { Tag } from "@chakra-ui/react";
import { StatusManutencaoEnum } from "core/features/manutencao/typings";

interface FiltroTipoStatusProps {
  selectedTipoStatus?: string;
  setSelectedTipoStatus?: (id?: string) => any;
  onSelectEmAtraso?: () => any;
  selectedEmAtraso?: boolean;
}

function TagStatus({
  onClick,
  selected,
  children,
}: {
  onClick: () => any;
  selected: boolean;
  children: React.ReactNode;
}) {
  return (
    <Tag
      bg={selected ? colors.blue500 : colors.lightGray}
      color={selected ? colors.white : colors.black}
      borderRadius={20}
      mr={2}
      mb={2}
      p={2}
      _hover={{
        background: `${colors.blue500}`,
        color: `${colors.white}`,
      }}
      transition="all 0.3s"
      onClick={onClick}
      cursor="pointer"
      fontWeight="normal"
    >
      {children}
    </Tag>
  );
}

function FiltroTagStatusManutencao({
  selectedTipoStatus,
  setSelectedTipoStatus,
  onSelectEmAtraso,
  selectedEmAtraso,
}: FiltroTipoStatusProps) {
  const onSelectTipoStatus = (t?: string) => {
    if (selectedTipoStatus === t) {
      setSelectedTipoStatus?.(undefined);
    } else {
      setSelectedTipoStatus?.(t);
    }
  };

  const items = StatusManutencaoEnum;

  return (
    <>
      <TagStatus
        onClick={() => onSelectTipoStatus?.(undefined)}
        selected={selectedTipoStatus === undefined && !selectedEmAtraso}
      >
        Todos
      </TagStatus>
      <TagStatus
        onClick={() => onSelectEmAtraso?.()}
        selected={selectedEmAtraso ?? false}
      >
        Em atraso
      </TagStatus>
      {(Object.keys(items) as (keyof typeof items)[]).map((key) => (
        <TagStatus
          onClick={() => onSelectTipoStatus?.(items[key])}
          selected={selectedTipoStatus === items[key]}
        >
          {getTextForKey(key)}
        </TagStatus>
      ))}
    </>
  );
}

const getTextForKey = (key: keyof typeof StatusManutencaoEnum) => {
  switch (key) {
    case "Concluida":
      return "Concluída";
    case "NaoRealizada":
      return "Não Realizada";
    case "Pendente":
      return "Pendente";
    default:
      return key;
  }
};
export default FiltroTagStatusManutencao;
